import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Panel from '@views/Panels/Panel'
import Button from '@components/Button'
import Text from '@components/Text'
import Divider from '@components/Divider'
import {
    PANEL_TRANSITION_TYPES,
    DIVIDER_SIZE,
} from '@helpers/constants'
import { AppContext } from '@state/context'
import BlockRenderer from '@views/BlockRenderer'

const ExerciseHeader = (props) => {
    const { children, exerciseName, closePanel, openPanel , text } = props
    const [state] = useContext(AppContext)

    return (
        <>
            <Panel
                transitionType={PANEL_TRANSITION_TYPES.FROM_LEFT}
                visible={openPanel}
                width={props.width ?? state.panels.sideBarWidth + 'px'}
                overHeader={true}
            >
                <div className={'flex items-center justify-between'}>
                    <BlockRenderer content={exerciseName} />
                    <div className={'self-start'}>
                        <Button
                            size={'noPadding'}
                            icon={'Close'}
                            iconRight
                            handleClick={() => closePanel()}
                        />
                    </div>
                </div>

                {text &&
                    <>
                        <Divider size={DIVIDER_SIZE.SMALL} />
                        <Text>{text}</Text>
                    </>
                }
                <Divider size={DIVIDER_SIZE.SMALL} line />
                <div className={'whitespace-pre-line h-full'}>
                    {children}
                </div>
            </Panel>
        </>
    )
}

ExerciseHeader.propTypes = {
    children: PropTypes.any,
    exerciseName: PropTypes.string,
    closePanel: PropTypes.func,
    openPanel: PropTypes.bool,
}

export default ExerciseHeader
